var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"link":"","to":_vm.nav.to,"exact-active-class":"active"}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-"+_vm._s(_vm.nav.icon))])],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm.nav.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }